import { PartialLayerSpec } from '@/utils/layers/styleFactory/template'
import { ILayerValue } from '@lifk/types'
import { ExpressionSpecification } from 'mapbox-gl'

export default (
  layerValues: ILayerValue[],
  mapboxColorExpression: string | ExpressionSpecification
): PartialLayerSpec[] => {
  const layerMax = Math.max(
    ...layerValues.map((lv) => lv.styleConfig.maxValue ?? 0)
  )
  return [
    {
      id: 'particle',
      type: 'raster-particle',
      paint: {
        'raster-particle-elevation': 10, // TODO: make configurable (our wind data is 10 meters tho)
        'raster-particle-speed-factor': 0.99, // higher speed = longer tails, more active looking
        'raster-particle-fade-opacity-factor': 0.75, // Lower = shorter tails. 1 = no fadeout.
        'raster-particle-reset-rate-factor': 0.4, // higher = lose directionality (resets too quickly). lower = sparse density.
        'raster-particle-count': 128, // density of particles in each tile
        // 'raster-opacity': 0.8
        'raster-particle-max-speed': layerMax,
        'raster-particle-color': mapboxColorExpression
      }
    }
  ] as PartialLayerSpec[]
}
